/** An Element Open Event */
export default class Open extends CustomEvent {
    constructor(caller) {
        super('open', {
            bubbles: false,
            detail: {
                caller
            }
        });
    }
}
